'use es6';

import get from 'hs-lodash/get';
import { NOT_REQUESTED } from 'forms-utils-lib/RequestState';
import { getPaymentTestHrefFromId, paymentLinkOnForm, paymentOptionsHaveChanged, getIsMultiplePaymentLinks } from 'FormsUI/utils/PaymentsUtils';
import { getPaymentFieldFromFormDefinition, getPublishedPaymentField } from 'FormsUI/selectors/FormDefinition';
import { hasFormsWriteAccess, hasPaymentLinksRead } from './Scope';
import { isUngatedForOverridePaymentPermissions } from './Gates';
import { getPaymentField } from 'FormsUI/selectors/FormDefinition';
import { getIsSinglePaymentLink, getSinglePaymentLinkLabel } from 'FormsUI/utils/PaymentsUtils';
import { createSelector } from 'reselect';
export const getIsPaymentsPermissionsGranted = state => hasPaymentLinksRead(state) && hasFormsWriteAccess(state);
export const getIsPaymentsAvailable = state => getIsPaymentsPermissionsGranted(state);
const getPayments = state => state.payments;
export const getPaymentsDataRequestState = state => getPayments(state).dataRequestState;
export const getPaymentEligibilityRequestState = state => getPayments(state).eligibilityRequestState;
export const getPaymentEligibility = state => getPayments(state).paymentEligibility;
export const getPaymentsData = state => getPayments(state).paymentsData;
export const getIsPaymentsConfigured = createSelector(getIsPaymentsAvailable, getPaymentEligibilityRequestState, getPaymentEligibility, isUngatedForOverridePaymentPermissions, (paymentsAvailable, paymentEligibilityRequestState, paymentEligibility, ungatedForOverridePaymentPermissions) => {
  const chargedEnabled = paymentEligibility.chargesEnabled || ungatedForOverridePaymentPermissions;
  return paymentsAvailable && paymentEligibilityRequestState.isSuccessful() && chargedEnabled;
});
export const getPaymentsToggleState = createSelector(getPaymentFieldFromFormDefinition, getIsPaymentsConfigured, (paymentField, isPaymentsConfigured) => {
  if (!isPaymentsConfigured) return false;
  return Boolean(paymentField);
});
export const getIsPaymentLinkOnForm = createSelector(getPaymentFieldFromFormDefinition, paymentField => paymentField && paymentLinkOnForm(paymentField.options));
export const getIsPaymentsEnabled = createSelector(getIsPaymentLinkOnForm, getIsPaymentsConfigured, (isPaymentLinkOnForm, isPaymentsConfigured) => isPaymentsConfigured && isPaymentLinkOnForm);
export const getShouldDowngradePaymentExperience = createSelector(getIsPaymentLinkOnForm, getIsPaymentsConfigured, (isPaymentLinkOnForm, isPaymentsConfigured) => !isPaymentsConfigured && isPaymentLinkOnForm);
export const getIsPaymentsChanged = createSelector(getIsPaymentsConfigured, getPaymentFieldFromFormDefinition, getPublishedPaymentField, (isPaymentsConfigured, draftPaymentField, publishedPaymentField) => {
  if (!isPaymentsConfigured) return false;
  if (!draftPaymentField && !!publishedPaymentField) return true;
  if (!publishedPaymentField) return false;
  const draftOptions = draftPaymentField.options;
  const publishedOptions = publishedPaymentField.options;
  return paymentOptionsHaveChanged(draftOptions, publishedOptions);
});
export const getActivePaymentSessionTemplateId = createSelector(getPaymentFieldFromFormDefinition, paymentField => {
  if (paymentField) {
    const {
      options,
      selectedOptions
    } = paymentField;
    if (selectedOptions.length >= 1) {
      return Number(selectedOptions[0]);
    } else {
      if (options.length >= 1) return Number(options[0].value);
      return null;
    }
  }
  return undefined;
});
export const getPaymentHref = createSelector(getPaymentsData, getIsPaymentsEnabled, getActivePaymentSessionTemplateId, (paymentsData, paymentsEnabled, activePaymentSessionTemplateId) => {
  return paymentsEnabled ? getPaymentTestHrefFromId(paymentsData, activePaymentSessionTemplateId) : undefined;
});
export const getCheckoutSessionPreviewRequestState = state => get(state, `payments.checkoutSessionPreview[${getActivePaymentSessionTemplateId(state)}].requestState`, NOT_REQUESTED);
export const getCheckoutSessionPreview = state => get(state, `payments.checkoutSessionPreview[${getActivePaymentSessionTemplateId(state)}].id`, '');
export const getPaymentLabel = state => {
  const paymentField = getPaymentField(state);
  const isSinglePaymentLink = getIsSinglePaymentLink(paymentField);
  return isSinglePaymentLink ? getSinglePaymentLinkLabel(paymentField) : null;
};
export const getHasMultiplePaymentLinks = state => {
  const paymentField = getPaymentField(state);
  return paymentField && getIsMultiplePaymentLinks(paymentField);
};
export const getHasSinglePaymentLink = state => {
  const paymentField = getPaymentField(state);
  return paymentField && getIsSinglePaymentLink(paymentField);
};